import store from '../store';
import assessmentRouter from './assessmentstate'
import {loadLocaleMessages} from "../plugins/i18n";

export const languageLoadGuard = (to, from, next)=>{
  loadLocaleMessages(store.state.language.locale).then(()=>{
    return next();
  }).catch(()=>{
    return next('/error');
  });
};

export const breakGuard = (to, from, next)=>{
  if(store.state.auth.onBreak){
    return next('/break');
  }else{
    return next();
  }
};

export const authGuard = (to, from, next)=>{
   if(store.state.auth.authToken){
     return next();
   }else if(store.state.auth.assessmenttoken){
     return next('/logintoken');
   }else{
     return next('/login');
   }
};

export const unauthenticatedGuard = (to, from, next)=>{
  if(!store.state.auth.authToken){
    return next();
  }else if(store.state.auth.assessmenttoken){
    store.dispatch('auth/logout',{clearAssessmenttoken:false,navigate:true});
  }else{
    assessmentRouter((route)=>{
      next(route);
    });
  }
};

export const assessmenttokenGuard = (to, from, next)=>{
  if(store.state.auth.assessmenttoken){
     next();
  }else{
     next('/login');
  }
};

export const speedTestGuard = (to, from, next)=>{
  if(store.state.speedtest.passed){
     next();
  }else {
     next('/connection');
  }
};

export const unverifiedPersonGuard = (to, from, next)=>{
  const assessment=store.state.assessment.assessment;
  if(assessment.person.personid && !assessment.person.verified_at){
    next();
  }else {
    assessmentRouter((route)=>{
      next(route);
    });
  }
};

export const verifiedPersonGuard = (to, from, next)=>{
  const assessment=store.state.assessment.assessment;
  if(!assessment){
    console.warning('Assessment empty: Logging out');
  }else if(assessment.person.personid && assessment.person.verified_at){
    next();
  }else {
    next('/register');
  }
};

export const hasLanguagePreference = (to, from, next)=>{
  const assessment=store.state.assessment.assessment;
  if(!assessment){
    console.warning('Assessment empty: Logging out');
  }else if(assessment.languageid){
    next();
  }else {
    next({name:'Language',params:{nextRoute:to}});
  }
};

export const hasProfilePicture = (to, from, next)=>{
  const assessment=store.state.assessment.assessment;
  if(!assessment){
    console.warning('Assessment empty: Logging out');
  }else if(assessment.profilepic){
    next();
  }else {
    next('/register/picture');
  }
};
